/**
 * @file: support.service.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { config } from '@euler/config';
import { HttpClient } from '@euler/lib/request';
import { AppSharingInfo, AppVersionInfo } from '@euler/model';
import { HelpVideoInfo } from '@euler/model/HelpVideoInfo';

export class SupportService {
  constructor(private readonly api: HttpClient) {}

  async getHelpVideos(): Promise<HelpVideoInfo[]> {
    return await this.api.get().url('/support/help/videos').future();
  }

  async getAppSharingInfo(): Promise<AppSharingInfo> {
    return await this.api.get().url('/app/sharing-info').future();
  }

  async getAppVersionInfo(): Promise<AppVersionInfo> {
    return await this.api
      .get()
      .url('/app/version-info', {
        target: config.target,
      })
      .future();
  }

  async echo(s?: string): Promise<string> {
    return await this.api.get().url('/echo', { s }).future();
  }
}
